// @flow

import * as React from "react"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"

import {
  fetchBabiesPaged,
  setBabiesFilter,
  resetBabiesFilters,
} from "../actions/babies"
import {filterableBabyStates} from "../types"
import type {Dispatch, BabyMadam} from "../types"

type Props = {
  dispatch: Dispatch,
  madams: $ReadOnlyArray<BabyMadam>,
  showState?: boolean,
  t: any,
}

class BabiesFilters extends React.Component<Props> {
  handleFilterChange: (SyntheticInputEvent<HTMLSelectElement>) => void
  handleResetClick: (SyntheticMouseEvent<HTMLLinkElement>) => void

  static defaultProps = {
    madams: [],
    showState: true,
  }

  constructor(props) {
    super(props)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleResetClick = this.handleResetClick.bind(this)
  }

  handleFilterChange(e: SyntheticInputEvent<HTMLSelectElement>) {
    const {name, value} = e.currentTarget
    this.props.dispatch(setBabiesFilter(name, value))
    this.props.dispatch(fetchBabiesPaged())
  }

  handleResetClick(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.props.dispatch(resetBabiesFilters())
    this.props.dispatch(fetchBabiesPaged())
  }

  render() {
    const {madams, t, showState} = this.props
    return (
      <div className="babies-filters filters mr-2">
        {showState ? (
          <>
            <span className="text-gray mr-2">
              {t("dashboard.babies.filter.label")}
            </span>
            <select
              className="filter form-control form-control-sm"
              name="state"
              onChange={this.handleFilterChange}
            >
              <option>{t("dashboard.babies.filter.property.state.all")}</option>
              {Object.keys(filterableBabyStates).map((f) => (
                <option key={`state-${f}`} value={f}>
                  {f}
                </option>
              ))}
            </select>
          </>
        ) : null}
        {madams.length > 1 && (
          <select
            className="filter form-control form-control-sm"
            name="madamId"
            onChange={this.handleFilterChange}
          >
            <option value="0">
              {t("dashboard.babies.filter.property.madamId.all")}
            </option>
            {this.props.madams.map((m) => (
              <option key={`madam-${m.id}`} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
        )}
      </div>
    )
  }
}

export default withTranslation()(connect()(BabiesFilters))
